<script setup lang="ts">
import OrgSettingsLayout from "@Modules/teams/Views/OrgSettingsLayout.vue"
import { XAuthStore } from "@Modules/users/Store/XAuthStore"
import { useCurrentOrganization } from "@Modules/teams/composables/useCurrentOrganization"
import SecuritySettings from "@Modules/security-settings/Views/SecuritySettings.vue"
import SecurityApi from "@Modules/security-settings/Api/SecurityApi"

//
// Setup
const { currentOrganization, currentWorkspace } = useCurrentOrganization()
const auth = XAuthStore()
const securityApi = SecurityApi()
</script>

<template>
  <OrgSettingsLayout
    v-if="currentOrganization"
    :organization="currentOrganization"
    :workspace="currentWorkspace"
  >
    <SecuritySettings
      :has-social-account="auth.userModel.hasSocialAccount"
      :is-two-factor-enabled="auth.userModel.isTwoFactorEnabled"
      :has-backup-codes="auth.userModel.hasBackupCodes"
      :backup-codes-created-date="securityApi.backupCodesCreatedDate.value"
      :errors="securityApi.errors.value"
      :loading="securityApi.loading.value"
      :update-password="securityApi.updatePassword"
      :enable-two-factor="securityApi.enableTwoFactor"
      :disable-two-factor="securityApi.disableTwoFactor"
      :generate-backup-codes="securityApi.generateBackupCodes"
      :delete-backup-codes="securityApi.deleteBackupCodes"
      :fetch-backup-codes-date="securityApi.fetchBackupCodesDate"
      :get-qr-code-url="securityApi.getQrCodeUrl"
      :verify-two-factor="securityApi.verifyTwoFactor"
      :refresh-application-state="auth.refreshUserState"
    />
  </OrgSettingsLayout>
</template>
